export function linksHandler(links = []) {
    if (links.length) {
        links.map(link => {
            const {
                type,
                id,
                lat,
                lng,
                text,
            } = link.dataset
            if (type || id) {
                link.addEventListener('click', e => {
                    e.preventDefault()
                    windowScrollOffset = window.scrollY
                    openModal(type, id, lat, lng, text)
                })
            }
        })
    }
}

export function modalHandler() {
    const links = [].slice.apply(document.querySelectorAll('.modal-link'))
    const closeBtns = [].slice.apply(document.querySelectorAll('.site-modal__close'))
    
    linksHandler(links)
    closeBtns.map(btn => btn.addEventListener('click', closeModal))
}

function renderMap(lat, lng, text) {
    const mapContainer = document.getElementsByClassName('site-modal__map')[0]
    const args = {
        zoom: 16,
        center: new google.maps.LatLng(0, 0),
        mapTypeId: google.maps.MapTypeId.ROADMAP,
    }
    //create map
    const map = new google.maps.Map(mapContainer, args)
    //add marker
    const latlng = new google.maps.LatLng(lat, lng)
    const marker = new google.maps.Marker({
        position: latlng,
        map: map,
    })
    
    const infowindow = new google.maps.InfoWindow({
        content: `<div class="google-marker">${text}</div>`,
    })
    google.maps.event.addListener(marker, 'click', function() {
        infowindow.open(map, marker)
    })
    
    //center map
    const bounds = new google.maps.LatLngBounds()
    bounds.extend(latlng)
    map.setCenter(bounds.getCenter())
    map.setZoom(16)
}

let windowScrollOffset = 0

function openModal(type, id, lat = '', lng = '', text = '') {
    if (type === 'form') {
        const modalContent = document.getElementsByClassName(`formid-${id}`)
        if (modalContent.length) {
            modalContent[0].classList.add('visible')
        }
        
        document.body.classList.add('form-modal-open')
    }
    
    if (type === 'employee') {
        jQuery
          .ajax({
              method: 'POST',
              url: window.MS_Ajax.ajaxurl,
              data: {
                  action: 'get-employee-data',
                  id,
              },
          })
          .done(data => {
              const modal = document.getElementsByClassName('employee-modal')[0]
              const modalContainer = modal.getElementsByClassName(
                'site-modal__content',
              )[0]
              modalContainer.innerHTML = renderEmployeeContent(data)
              modal.classList.add('visible')
          })
        
        // document.body.classList.add('modal-open');
    }
    
    if (type === 'map') {
        const modal = document.getElementsByClassName('map-modal')[0]
        modal.classList.add('visible')
        renderMap(lat, lng, text)
    }
    document.body.classList.add('modal-open')
}

function closeModal(e) {
    e.preventDefault()
    e.target.parentNode.classList.remove('visible')
    document.body.classList.remove('modal-open')
    document.body.classList.remove('form-modal-open')
    window.scroll(0, windowScrollOffset)
}


function renderEmployeeContent({
                                   phone,
                                   email,
                                   position,
                                   employee_year,
                                   first_employed,
                                   born,
                                   text,
                               }) {
    return `
      <div class="modal-content__item">
        <span class="modal-content__title">Telefon:</span>
        <a
          href="tel:${phone}"
          class="modal-content__text">
          ${phone}
        </a>
      </div>
      <div class="modal-content__item">
        <span class="modal-content__title">E-post:</span>
        <a
          href="mailto:${email}"
          class="modal-content__text">
          ${email}
        </a>
      </div>
      <div class="modal-content__item">
        <span class="modal-content__title">Position inom Bylero:</span>
        <span
          class="modal-content__text">
          ${position}
        </span>
      </div>
      <div class="modal-content__item">
        <span class="modal-content__title">Första anställningen inom aktuellt yrke:</span>
        <span
          class="modal-content__text">
          ${first_employed}
        </span>
      </div>
      <div class="modal-content__description wa-wysiwyg">
      ${text}
      </div>
    `
}